
import { useState } from "react";
import { Popover } from "antd";




const ActionPopoverContent = ({ closePopover, deleteLoan, sendMail, sendSMS }) => (
    <div className="text-center" style={{ minWidth: "180px" }}>
      <header className="text-right">
        <button onClick={closePopover}><i className="bi bi-x-lg"></i></button>
      </header>
      <div>
        <button onClick={sendMail} className="block my-2 w-full bg-primary-50 text-primary-600 px-4 py-2 rounded-md">
          Send Email
        </button>
        <button onClick={sendSMS} className="block my-2 w-full bg-secondary-50 text-secondary-600 px-4 py-2 rounded-md">
          Send SMS
        </button>
        <button onClick={deleteLoan} className="bg-red-600 text-white w-full px-4 py-2 block my-2 rounded-md font-medium">
          Delete Draft
        </button>
      </div>
    </div>
  );
  
  // --- ActionPopover ---
  export const ActionPopover = ({ loan, deleteLoanDraft, sendEmailReminder }) => {
    const [open, setOpen] = useState(false);
  
    const handleDeleteLoan = () => {
      deleteLoanDraft(loan.id);
      setOpen(false);
    };
  
    const handleSendMail = () => {
      sendEmailReminder(loan.id);
      setOpen(false);
    };
  
    const handleSendSMS = () => {
      // you can add SMS logic later
      setOpen(false);
    };
  
    return (
      <Popover
        content={
          <ActionPopoverContent
            closePopover={() => setOpen(false)}
            deleteLoan={handleDeleteLoan}
            sendMail={handleSendMail}
            sendSMS={handleSendSMS}
          />
        }
        placement="bottom"
        open={open}
        trigger="click"
        onOpenChange={(visible) => setOpen(visible)}
      >
        <button className="text-xl">
          <i className="bi bi-three-dots-vertical"></i>
        </button>
      </Popover>
    );
  };

